export default "__VITE_ASSET__DgQ$onXJ__"